import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../TimeModal/TimeModalContext';

import Loading from '../Loading';

import styles from '../../styles/DynamicModal.module.css';

import IconContainer from '../IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';

const EditEmailAM = ({ closeModal, id, regionId, action, onReloadTable }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        email: '',
        note: ''
    });
    const [loading, setLoading] = React.useState(true);
    const [status, setStatus] = React.useState(null);
    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    };

    const handleChange = (field) => (e) => {
        const value = e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));
        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
      const validateForm = () => {
      const newErrors = {};
    
        if (!formInfo.email) {
            newErrors.email = 'Обязательное поле';
        }
        if (formInfo.email) {
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formInfo.email)) {
                newErrors.email = (newErrors.email || '') + 'Введите корректный адрес электронной почты';
            }
            if (formInfo.email.length < 2 || formInfo.email.length > 100) {
                newErrors.email = (newErrors.email || '') + (newErrors.email ? '. ' : '') + 'Значение не может быть меньше 2 и более 100 символов';
            }
        }
        if (formInfo.note && (formInfo.note.length < 2 || formInfo.note.length > 100)) {
            newErrors.note = 'Значение не может быть меньше 2 и более 100 символов';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
          setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
          return false;
        } else {
          return true;
        }
    };

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) handleLogout();
        if (action=='change') {
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/email-am?id=${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные управляющего. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, []);


    const addData = () => {
        axios.post(`/api/add-new-email-am`, {
            email: formInfo.email,
            note: formInfo.note,
            regionId: regionId,
        })
        .then(() => {
            setStatus('Новый email добавлен');
            setFormInfo((prev) => ({
                ...prev,
                email: '',
                note: '',
            }));
            onReloadTable();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const changeData = () => {
        axios.put(`/api/change-emails-AM-data`, {
            id: formInfo.id,
            email: formInfo.email,
            note: formInfo.note,
        }).then(() => {
            setStatus('Данные арбитражного управляющего изменены');
            onReloadTable();
            closeModal();
        }).catch((error) => {
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);
        setFormInfo((prev) => ({
            ...prev,
            email: prev.email.trim(),
            note: prev.note.trim(),
        }))

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    }


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>{action=='add' && 'Добавление'} 
                        {action=='change' && 'Редактирование'}
                        &nbsp;адреса электронной почты арбитражного управляющего
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Адрес электронной почты</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.email} 
                                onChange={handleChange('email')} 
                                className={errorsForm.email ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='100' 
                                disabled={loading}
                                required />
                                {errorsForm.email && <div className='errorUnderInput'>{errorsForm.email}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Примечание</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.note} 
                                onChange={handleChange('note')} 
                                className={errorsForm.note ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.note && <div className='errorUnderInput'>{errorsForm.note}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                    Сохранить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditEmailAM;